import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';

interface ConfirmationDialogProps {
  open: boolean;
  title?: string;
  message: string;
  onConfirm: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onClose: () => void;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  open,
  title = 'Confirm Action',
  message,
  onConfirm,
  onClose,
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography dangerouslySetInnerHTML={{ __html: message }} />
      </DialogContent>
      <DialogActions sx={{ padding: '.5rem 1rem 1rem 1rem' }}>
        <Button onClick={onClose}>Close</Button>
        <Button
          onClick={(e) => {
            e.stopPropagation();
            onConfirm(e);
          }}
          variant="contained">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
